<template>
  <div id="home">
    <navigation />
    <mdb-container class="py-3 mx-auto">

      <div class="row my-3">
        <div class="col-md-12">
          <h1>Welcome to Thitch</h1>
          <h2>We got all the finger clickin’ good videos</h2>
          <p>The Death Star plans are not in the main computer. Where are those transmissions you intercepted? What have you done with those plans? We intercepted no transmissions. Aaah....This is a consular ship. Were on a diplomatic mission. If this is a consular ship...were is the Ambassador? Commander, tear this ship apart until you've found those plans and bring me the Ambassador. I want her alive! There she is! Set for stun! She'll be all right. Inform Lord Vader we have a prisoner.</p>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-md-12">
          <div class="category-wrapper">
            <form id="category-form">
              <select id="select" class="browser-default custom-select" v-model="select" placeholder="edit me">
                <!-- <option data-default selected placeholder value="">No Category</option> -->
                <option data-default selected placeholder value="all">All Videos</option>
                <option value="AI1">Introduction to Artificial Intelligence</option>
                <option value="CA">Cloud Architekturen</option>
                <option value="FPK">Fortgeschrittene Programmierkonzepte</option>
                <option value="IOT">Internet of things</option>
                <option value="IT(de)">IT Systems (de)</option>
                <option value="IT(en)">IT Systems (en)</option>
                <option value="KS">Kognitive Systeme</option>
                <option value="">No Category</option>
              </select>
              <mdb-btn color="#f9a825 yellow darken-3" icon="fas fa-filter" v-on:click="filterByCategory()" type="button" class="category-button">Filter</mdb-btn>
            </form>
          </div>

        </div>
      </div>

      <div class="row my-3">
          <div v-for="(video, i) in data" :key="i" class="mb-3 col-md-4 img-container">
            <a v-on:click="gotovideo(video.VideoId)">
              <div v-if="video.VideoThumbnailUri" class="img-wrapper">
                <img v-bind:src="video.VideoThumbnailUri" class="rounded thumbnail-img" alt="...">
                  <span class="video-title">{{video.VideoTitel}}</span>
              </div>
              <div v-else class="img-wrapper">
                <img src="../assets/filler.jpg" class="rounded thumbnail-img" alt="...">
                  <span class="video-title">{{video.VideoTitel}}</span>
              </div>      
            </a>
        </div>

      </div>
    </mdb-container>
  </div>
</template>

<script>
import { mdbContainer, mdbBtn} from "mdbvue";
import navigation from "@/components/navigation";

export default {
  name: "Home",
  components: {
    mdbContainer,
    mdbBtn,
    navigation
  },
  data() {
    return {
      data: null,
      tmp:null,
      select:null
    };
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.replace({ name: "login" });
    }
  },
  created() {
    this.getVideos();
    this.setSelect();
  },
  methods: {
    /** Get all Videos from Blob */
    async getVideos() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      };
      const res = await fetch(
        "https://thitch.azurewebsites.net/api/GetListOfVideos?code=MysZpKCaAJiIJRH2Kb6Fd0ZDuC0yRxiq8UUNya18b4aiKXcCnoFxYg==",
        requestOptions
      );
      const data = await res.json();

      // for loop to check if thumbnails exist (hack)
      data.forEach(video => {

        // Check if image exists
        var http = new XMLHttpRequest();
        http.open('HEAD', video.VideoThumbnailUri, false);
        http.send();

        if(http.status == 404) {
          video.VideoThumbnailUri = "https://thitchstorage.blob.core.windows.net/thitchimage/Thitch_filler.jpg";
        }

      });

      this.data = data;
      this.tmp = data;
      console.log("res ", this.data);
    },
    setSelect() {
      this.select = "all";
    },
    /** Go to Video by Uri */
    gotovideo: function(value) {
      this.$router.push({ path: `/video/${value}` });
    },
    /** Sort by given Category */
    async filterByCategory() {
      if(this.select == 'all') {
         this.data = this.tmp;
      } else {
        this.tmp.forEach(video => {
          if(video.VideoTags == this.select) {
            this.data.push(video);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
#home {
  background-color: #ffffff;
  border: 1px solid #cccccc;
}
.backg {
  background-color: #FF8863;
}
.buttonbackg{
  background-color: #D65DB1;
  color: white;
}
.video-title {
  font-size: 1.2rem;
  font-weight: 400;
  position: absolute;
  bottom: 15px;
  left: 45px;
  background: white;
  padding: 2px 7px;
  border-radius: 4px;
}
.thumbnail-img {
  width: 100%;
}
.img-wrapper {
  box-shadow: 6px 10px 22px -14px rgba(0,0,0,0.75);
    border-radius: 4px;
    max-height: 197px;
    overflow: hidden;
}
.img-wrapper:hover {
  box-shadow: 10px 10px 12px 0px rgba(179,157,219,1);
  cursor: pointer;
}
.category-wrapper {
  text-align: right;
}
.custom-select {
  max-width: 215px;
}
.category-button {
    padding-top: 9px;
    padding-bottom: 9px;
}
</style>